import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { DataRecoveryPriorityModesActions } from '../actions';
import { NotifierService } from 'angular-notifier';
import { DataRecoveryPriorityModesService } from '../../services/data-recovery-priority-modes.service';

@Injectable()
export class DataRecoveryPriorityModesEffects {
  readDataRecoveryPriorityMode$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DataRecoveryPriorityModesActions.ReadDataRecoveryPriorityMode),
      map(action => action),
      switchMap(({ iri }) => {
        return this.aps.getDataRecoveryPriorityMode(iri).pipe(
          map(response =>
            DataRecoveryPriorityModesActions.ReadDataRecoveryPriorityModeSuccess(
              { response }
            )
          ),
          catchError(response =>
            of(
              DataRecoveryPriorityModesActions.ReadDataRecoveryPriorityModeFail(
                { response }
              )
            )
          )
        );
      })
    )
  );
  readDataRecoveryPriorityModes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DataRecoveryPriorityModesActions.ReadDataRecoveryPriorityModes),
      map(action => action),
      switchMap(() => {
        return this.aps.getDataRecoveryPriorityModes().pipe(
          map(response =>
            DataRecoveryPriorityModesActions.ReadDataRecoveryPriorityModesSuccess(
              { response }
            )
          ),
          catchError(response =>
            of(
              DataRecoveryPriorityModesActions.ReadDataRecoveryPriorityModesFail(
                { response }
              )
            )
          )
        );
      })
    )
  );
  FailActions = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          DataRecoveryPriorityModesActions.ReadDataRecoveryPriorityModesFail,
          DataRecoveryPriorityModesActions.ReadDataRecoveryPriorityModeFail
        ),
        map(({ type, response }) => {
          console.log({ response });
          const errors = response?.error['hydra:description'];
          const message = 'Fehler bei der Anfrage: ' + errors;
          this.notifierService.show({ type: 'error', message });
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private aps: DataRecoveryPriorityModesService,
    private notifierService: NotifierService
  ) {}
}
